import React, { Component } from 'react';

export default class Home extends Component {
	render() {
		return (
			<div>
				<div>
					<div className="welcome-content">
						<h2 className="welcome-header">Welcome to Bradman</h2>
						<p>Now you can manage your operations in a better way. Please
							<a href="mailto:product-support@jumbotail.com"> contact us</a> if you have any feedback or comments.
						</p>
						<blockquote>
							<p>Organising the food and grocery ecosystem in India
								using technology, data science, and design.</p>
							<small>Jumbotail</small>
						</blockquote>
					</div>
				</div>
			</div>);
	}
}



// WEBPACK FOOTER //
// ./src/screens/Home/Components/Home.js